import { paths } from "../../config/paths";
import { LandingPage } from "../../features/landing-page/LandingPage";

export const FragranceProfilerHome = () => {
  return (
    <LandingPage
      backgroundPath="/fragrance-profiler/landing-page.mp4"
      subtitle="Find Your"
      title="Fragrance"
      description="Step into your allure of confidence"
      path={paths.fragranceProfiler.profiler.path}
    />
  );
};
